import React, { useState, useEffect } from "react";
import { Form, Button, Card, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import "./hostel.css";
import {
  addFoodMealItem,
  updateFoodMealItem,
} from "./hostelServices/foodMenuServices";

const CATEGORY_TYPES = [
  { value: "MAIN", label: "Main Course" },
  { value: "SIDE", label: "Side Dish" },
  { value: "DESSERT", label: "Dessert" },
];

const ITEM_TYPES = [
  { value: "GLUTEN_FREE", label: "Gluten Free" },
  { value: "VEGAN", label: "Vegan" },
  { value: "VEG", label: "Vegetarian" },
  { value: "NON_VEG", label: "Non-Vegetarian" },
  { value: "DAIRY_FREE", label: "Dairy Fee" },
  { value: "SUGAR_FREE", label: "Sugar Free" },
];

const UNITS = [
  { value: "GRAM", label: "Gram" },
  { value: "KG", label: "Kilogram" },
  { value: "CUP", label: "Cup" },
  { value: "LITER", label: "Liter" },
  { value: "PIECE", label: "Piece" },
  { value: "PLATE", label: "Plate" },
];

const AddMenuMealItemCompo = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  const isEditing = modalState.isEditing;

  const hostelId = modalState.id;
  const menuId = modalState.foodMenuId;
  const mealId = modalState.mealId;

  console.log("Master data:", masterData);
  console.log("Is editing:", isEditing);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "",
    itemType: "",
    unit: "",
    quantity: "",
    isUnlimited: "N",
    hostelId,
    menuId,
    mealId,
    id: null,
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getProperty = (obj, propName) => {
    if (!obj) return null;

    if (obj[propName] !== undefined) return obj[propName];

    const lowerPropName = propName.toLowerCase();
    for (const key of Object.keys(obj)) {
      if (key.toLowerCase() === lowerPropName) {
        return obj[key];
      }
    }
    return null;
  };

  useEffect(() => {
    if (masterData && isEditing) {
      console.log("Setting form data from masterData:", masterData);
  
      const name = getProperty(masterData, "NAME") || getProperty(masterData, "name");
      const description = getProperty(masterData, "DESCRIPTION") || getProperty(masterData, "description");
      
      let category = getProperty(masterData, "CATEGORY") || getProperty(masterData, "category");
      if (category) {
        const categoryMapping = {
          "Main": "MAIN",
          "Main Course": "MAIN", 
          "Side": "SIDE",
          "Side Dish": "SIDE",
          "Dessert": "DESSERT"
        };
        category = categoryMapping[category] || category;
      }
      
      let itemType = getProperty(masterData, "ITEM TYPE") || getProperty(masterData, "itemType");
      if (itemType) {
        const itemTypeMapping = {
          "Gluten Free": "GLUTEN_FREE",
          "Gluten fee": "GLUTEN_FREE",
          "Vegan": "VEGAN",
          "Vegetarian": "VEG",
          "Non-Vegetarian": "NON_VEG",
          "Dairy Free": "DAIRY_FREE", 
          "Dairy Fee": "DAIRY_FREE",
          "Sugar Free": "SUGAR_FREE"
        };
        itemType = itemTypeMapping[itemType] || itemType;
      }
      
      let unit = getProperty(masterData, "_UNIT") || getProperty(masterData, "unit");
      if (unit) {
        const unitMapping = {
          "Gram": "GRAM",
          "Kilogram": "KG",
          "Cup": "CUP", 
          "Liter": "LITER",
          "Piece": "PIECE",
          "Plate": "PLATE"
        };
        unit = unitMapping[unit] || unit;
      }
      
      const quantity = getProperty(masterData, "_QUANTITY") || getProperty(masterData, "quantity");
      
      const isUnlimited = getProperty(masterData, "UNLIMITED") || 
                        getProperty(masterData, "IS_UNLIMITED") || 
                        getProperty(masterData, "isUnlimited") || 
                        "N";
      
      const id = getProperty(masterData, "_ID") || getProperty(masterData, "id");
  
      const correctHostelId = getProperty(masterData, "_HOSTEL") || getProperty(masterData, "hostelId") || hostelId;
      const correctMenuId = getProperty(masterData, "_MENU") || getProperty(masterData, "menuId") || menuId;
      const correctMealId = getProperty(masterData, "_MEAL") || getProperty(masterData, "mealId") || mealId;
  
      setFormData({
        name: name || "",
        description: description || "",
        category: category || "",
        itemType: itemType || "",
        unit: unit || "",
        quantity: quantity || "",
        isUnlimited: isUnlimited || "N",
        hostelId: correctHostelId,
        menuId: correctMenuId,
        mealId: correctMealId,
        id: id || null,
      });
  
      console.log("Form data set for editing:", {
        name,
        description,
        category,
        itemType,
        unit,
        quantity,
        isUnlimited,
        hostelId: correctHostelId,
        menuId: correctMenuId,
        mealId: correctMealId,
        id,
      });
    }
  }, [masterData, isEditing, hostelId, menuId, mealId]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "isUnlimited" && {
        quantity: value === "Y" ? "1" : "",
      }),
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Item name is required";
    if (!formData.description?.trim())
      newErrors.description = "Description is required";
    if (!formData.category) newErrors.category = "Category is required";
    if (!formData.itemType) newErrors.itemType = "Item type is required";
    if (!formData.unit) newErrors.unit = "Unit is required";
    if (formData.isUnlimited === "N" && !formData.quantity) {
      newErrors.quantity = "Quantity is required when item is not unlimited";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const dataToSend = {
        ...formData,
        hostelId: formData.hostelId || hostelId,
        menuId: formData.menuId || menuId,
        mealId: formData.mealId || mealId,
      };

      console.log("Submitting data:", dataToSend);

      const response = isEditing
        ? await updateFoodMealItem(dataToSend)
        : await addFoodMealItem(dataToSend);

      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          `Menu item ${isEditing ? "updated" : "added"} successfully!`,
          myButton
        );
        await refresh?.({ columnRefresh: false, isLoading: false });
        closeModal();
      } else {
        showErrorMessages({ data: response, navigate });
      }
    } catch (error) {
      showErrorMessages({
        data: {
          message: `Failed to ${isEditing ? "update" : "add"} menu item`,
          errors: error.message,
        },
        navigate,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="shadow-sm">
      <Card.Body className="px-4 py-4">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Item Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter item name"
                  isInvalid={!!errors.name}
                  className="shadow-sm"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Category</Form.Label>
                <Form.Select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  isInvalid={!!errors.category}
                  className="shadow-sm"
                >
                  <option value="">Select category</option>
                  {CATEGORY_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.category}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Item Type</Form.Label>
                <Form.Select
                  name="itemType"
                  value={formData.itemType}
                  onChange={handleInputChange}
                  isInvalid={!!errors.itemType}
                  className="shadow-sm"
                >
                  <option value="">Select item type</option>
                  {ITEM_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.itemType}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Unit</Form.Label>
                <Form.Select
                  name="unit"
                  value={formData.unit}
                  onChange={handleInputChange}
                  isInvalid={!!errors.unit}
                  className="shadow-sm"
                >
                  <option value="">Select unit</option>
                  {UNITS.map((unit) => (
                    <option key={unit.value} value={unit.value}>
                      {unit.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.unit}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label className="fw-bold">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter item description"
                  isInvalid={!!errors.description}
                  className="shadow-sm"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.description}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Unlimited Item?</Form.Label>
                <Form.Select
                  name="isUnlimited"
                  value={formData.isUnlimited}
                  onChange={handleInputChange}
                  className="shadow-sm"
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {formData.isUnlimited === "N" && (
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-bold">Quantity</Form.Label>
                  <Form.Control
                    type="number"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleInputChange}
                    placeholder="Enter quantity"
                    isInvalid={!!errors.quantity}
                    className="shadow-sm"
                    min="1"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.quantity}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            )}
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="px-4"
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {isEditing ? "Updating..." : "Adding..."}
                </>
              ) : isEditing ? (
                "Update Menu Item"
              ) : (
                "Add Menu Item"
              )}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddMenuMealItemCompo;
